// fires dragging event with a mouse delta since last update 
export function dragger(node) {
  let prev = {}
  let delta = {x:0,y:0}
  let isDragging = false
  const dragStart = (e)=>{
    e.preventDefault()
    e.stopPropagation()
    delta = {x:0,y:0}
    let {clientX,clientY} = e.touches ? e.touches[0] : e
    prev.x = clientX
    prev.y = clientY
    isDragging = true
    document.addEventListener("mousemove",dragging)
    document.addEventListener("mouseup",dragEnd)
    document.addEventListener("touchmove",dragging, {passive: false})
    document.addEventListener("touchend",dragEnd)
    node.dispatchEvent(new CustomEvent('dragstart'));
  }
  const dragging = (e)=>{
    e.preventDefault()
    let {clientX,clientY} = e.touches ? e.touches[0] : e
    delta = { x: clientX-prev.x, y: clientY-prev.y }
    prev = {x: clientX, y: clientY }
    node.dispatchEvent(new CustomEvent('dragging', { detail: {delta} }));
  }

  const dragEnd = (e)=>{
    isDragging = false
    document.removeEventListener("mousemove",dragging)
    document.removeEventListener("mouseup",dragEnd)
    document.removeEventListener("touchmove",dragging)
    document.removeEventListener("touchend",dragEnd)
    node.dispatchEvent(new CustomEvent('dragend'));
  }

  node.addEventListener("mousedown",dragStart)
  node.addEventListener("touchstart",dragStart)
  return {
    destroy() {
      if(isDragging) dragEnd()
      node.removeEventListener("mousedown",dragStart)
      node.removeEventListener("touchdown",dragStart)
    }
  };
}

// sets the height of a textarea based on it's content
export function autoheight(node){
  function autoExpand(){
    node.style.height = 'inherit'; // Reset field height
    var computed = window.getComputedStyle(node); // Get the computed styles for the element
    // Calculate the height
    var height = parseInt(computed.getPropertyValue('border-top-width'), 10)
                + parseInt(computed.getPropertyValue('padding-top'), 10)
                + node.scrollHeight
                + parseInt(computed.getPropertyValue('padding-bottom'), 10)
                + parseInt(computed.getPropertyValue('border-bottom-width'), 10);
    node.style.height = height + 'px';
  }
  node.addEventListener("input",autoExpand)
  autoExpand()
  return {
    destroy() {
      node.removeEventListener("input",autoExpand)
    }
  }
}

// used to turn a div into a drag and drop file upload area
export function dropfiles(node,params){
  const handleDrop = (e)=>{
    e.preventDefault()
    if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length){
      let files = e.dataTransfer.files    
      if(params.ondropped){
        params.ondropped(files)
      }
    }
  }

  const handleDragOver = (e)=>{
    if(e.dataTransfer) e.dataTransfer.dropEffect = "copy"
    e.preventDefault()
  }
  node.addEventListener("dragover",handleDragOver)
  node.addEventListener("drop",handleDrop)
  return {
    destroy() {
      node.removeEventListener("dragover",handleDragOver)
      node.removeEventListener("drop",handleDrop)    
    }
  };

}
